import { render, staticRenderFns } from "./ReportesCreditoList.vue?vue&type=template&id=2d4874ce&scoped=true&lang=html&"
import script from "./ReportesCreditoList.vue?vue&type=script&lang=js&"
export * from "./ReportesCreditoList.vue?vue&type=script&lang=js&"
import style0 from "./ReportesCreditoList.vue?vue&type=style&index=0&id=2d4874ce&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4874ce",
  null
  
)

export default component.exports